import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApiService } from "../../../../../../api/api.service";

export function OrganisationNameIsUnique() {
    return registerAsyncValidatorDecorator({
        name: "OrganisationNameIsUniqueValidator"
    });
}

@Injectable()
export class OrganisationNameIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "OrganisationNameIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value || control.value === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.organisations.nameExists(control.value).pipe(
                    map((isNewOrganisationNameValid) => {
                        if (!isNewOrganisationNameValid) {
                            control.markAsTouched();
                            return { organisation_name_already_used: true };
                        }
                        return null;
                    })
                )
            )
        );
    }
}
